export default __webpack_public_path__ + "static/media/kokoro-2.c59c11b9.png";